import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { transactionsService } from "../../../app/services/transactionService";
import { useForm } from "react-hook-form";
import { formatDate } from "../../../app/utils/formatDate";
import { formatCpfNumber } from "../../../app/utils/cpfFormater";
import { formatZipCode } from "../../../app/utils/formatZipCode";
import { states } from "../../../app/utils/states";
import { customerService } from "@/app/services/customerService";
import { Table } from "@/app/services/transactionService/getAvailableCredit";
import { useGetAvailableCredit } from "@/app/hooks/useGetAvailableCredit";

const quotas = [
  {
    value: "1",
    label: 1,
  },
  {
    value: "2",
    label: 2,
  },
  {
    value: "3",
    label: 3,
  },
  {
    value: "4",
    label: 4,
  },
  {
    value: "5",
    label: 5,
  },
  {
    value: "6",
    label: 6,
  },
  {
    value: "7",
    label: 7,
  },
  {
    value: "8",
    label: 8,
  },
  {
    value: "9",
    label: 9,
  },
  {
    value: "10",
    label: 10,
  },
  {
    value: "11",
    label: 11,
  },
  {
    value: "12",
    label: 12,
  },
];

export default function useWithdrawSimulation() {
  const { cpf } = useParams();
  const [selectedTable, setSelectedTable] = useState<Table | null>(null);

  const availableCredit = useGetAvailableCredit(Number(cpf));
  const { data: customer, isLoading: customerIsLoading } = useQuery({
    queryKey: ["getCustomer", cpf],
    queryFn: () => (cpf ? customerService.customerInfo(cpf) : undefined),
  });

  const customerId = customer?._id;
  const transactionChart = useQuery({
    queryKey: ["transactionChart", customerId],
    queryFn: () =>
      customerId
        ? transactionsService.transactionChart({ customerIds: customerId })
        : undefined,
  });

  const [selectTab, setSelectedTab] = useState(0);
  const [skip, setSkip] = useState(0);

  const tabs = {
    tables: selectTab === 0,
    transaction: selectTab === 1,
    personalInfo: selectTab === 2,
  };

  const transactions = useQuery({
    queryKey: ["transactions", "allTransactions", skip, customerId],
    queryFn: () => {
      if (customerId)
        return transactionsService.transaction({
          skip,
          customerIds: customerId,
        });
    },
  });

  const form = useForm();

  const { reset } = form;

  const handleQuotaChange = (quota: string, event?: React.SyntheticEvent) => {
    if (event) {
      event.stopPropagation();
    }
    availableCredit.setParams({ prazo: Number(quota) });
  };

  useEffect(() => {
    if (customer) {
      reset({
        ...customer,
        birthDate: customer.birthDate ? formatDate(customer.birthDate) : "",

        cpf: customer.cpf ? formatCpfNumber(customer.cpf.toString()) : "",

        address: {
          ...customer.address,
          zipCode: customer.address?.zipCode
            ? formatZipCode(customer.address.zipCode)
            : "",

          state:
            states.find(({ value }) => value === customer.address?.state)
              ?.label ?? "",
        },

        bankAccount: {
          ...customer.bankAccount,
        },
      });
    }
  }, [customer, reset]);

  useEffect(() => {
    if (
      availableCredit?.data &&
      availableCredit.data.tables?.[0] &&
      selectedTable === null
    )
      setSelectedTable(availableCredit.data.tables[0]);
  }, [availableCredit.data, availableCredit?.data?.tables, selectedTable]);

  return {
    transactions,
    availableCredit,
    form,
    tabs,
    setSelectedTab,
    setSkip,
    transactionChart,
    cpf,
    selectedTable,
    setSelectedTable,
    customer: { data: customer, isLoading: customerIsLoading },
    quotas,
    handleQuotaChange,
  };
}
